import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/data-hora`

    return {
        get(queryParms = {}) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        }
    }
}